export default __webpack_public_path__ + "images/d73a42c1c51dddd940d5f22f09fd3093-iconos_youtube.svg";